module.exports = __webpack_public_path__ + "static/monkey-d5ce3dc9bf9180f3b7bbdc26f068f7a9.svg";